import { Box, Table } from '@mui/material';

const Minimums = () => (
  <Box id="help_minimums" className="tab-pane" padding={1}>
    <Box sx={{ display: 'flex', flexWrap: 'wrap' }} className="row">
      <Box className="col-md-12">
        <Table
          className="table"
          sx={{
            borderTop: '1px solid rgb(222, 226, 230)',
            borderBottom: '1px solid rgb(222, 226, 230)',
            '& th': { paddingX: '0.75rem', paddingBottom: '0.75rem' },
            '& td': {
              padding: '0.75rem',
              borderTop: '1px solid rgb(222, 226, 230)',
            },
          }}
        >
          <thead>
            <tr>
              <th>LCI&reg; Report Dimension</th>
              <th>Mobile App Min Imps w/ Valid Device IDs *</th>
              <th>Mobile Web/Desktop Min Imps</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Location Conversion Index® – Campaign</td>
              <td>10 MM</td>
              <td>25 MM</td>
            </tr>
            <tr>
              <td>Location Conversion Index® – By Audience</td>
              <td>10 MM per audience</td>
              <td>25 MM per audience</td>
            </tr>
            <tr>
              <td>Location Conversion Index® – By Creative</td>
              <td>10 MM per creative</td>
              <td>25 MM per creative</td>
            </tr>
            <tr>
              <td>Location Conversion Index® – By IO Line</td>
              <td>10 MM per IO line</td>
              <td>25 MM per IO line</td>
            </tr>
            <tr>
              <td>Location Conversion Index® – By Channel Partner</td>
              <td>10 MM per channel</td>
              <td>25 MM per channel</td>
            </tr>
            <tr>
              <td>Location Conversion Index® – By Site</td>
              <td>10 MM per site</td>
              <td>25 MM per site</td>
            </tr>
            <tr>
              <td>Location Conversion Index® – By Placement</td>
              <td>10 MM per placement</td>
              <td>25 MM per placement</td>
            </tr>
          </tbody>
        </Table>
      </Box>
      <p className="col-sm-12">
        <em>
          <strong>* Note:</strong> Feasibility assessment required by InMarket
          Product Team to request waiver of required minimum campaign
          impressions.
        </em>
      </p>
    </Box>
  </Box>
);

export default Minimums;
